<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form" ref="form">
      <!--begin::Form-->
      <form class="kt-form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row mb-3">
              <div class="col-xl-6">
                <input
                  type="file"
                  class="custom-file-input"
                  id="importFileBarcode"
                  lang="es"
                />
                <label class="custom-file-label" for="importFileBarcode">{{
                  Flie
                }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="PreviewTable"
                  style="width: 100%;"
                ></table>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="reset" class="btn btn-danger" @click="resetFile">
            <i class="la la-close"></i> ล้างค่า
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var self = this;
    return {
      Flie: "เลือกไฟล์",
      seen: false,
      isPass: true,
      barcodeList: [],
      barcodeListWarning: [],
    };
  },
  methods: {
    resetFile: function() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFileBarcode").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.isPass = true;
      this.barcodeList = [];
    },
    formSubmit: function(e) {
      e.preventDefault();

      if (!this.isPass) {
        Swal.fire("กรุณาตรวจสอบข้อมูลให้ถูกต้อง", "", "warning");
        return false;
      }
      if (this.barcodeList.length < 1) {
        Swal.fire("กรุณาเลือกไฟล์ก่อนบันทึกข้อมูล", "", "warning");
        return false;
      }

      var valid = false;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let self = this;
      let router = this.$router;
      axios
        .post("/Api/Barcode/Import", this.barcodeList)
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#importFileBarcode").change(function(e) {
      self.seen = true;
      self.Flie = e.target.files[0].name;

      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแสดงข้อมูล กรุณารอสักครู่...",
      });

      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      axios
        .post("/Api/Barcode/Preview", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          self.barcodeList = response.data;
          var $table = $("#PreviewTable");

          var hasBarcodeId = response.data.some(item => item.BarcodeId != null && item.BarcodeId > 0);

          var head =
            '<thead>' +
            '<tr role="row">' +
            '<th class="text-center">ลำดับ</th>' +
            '<th class="text-center" style="width:8%;">BARCODE</th>' +
            '<th class="text-center" style="width:10%;">รหัสทรัพย์สิน(เบียร์สด)</th>' +
            '<th class="text-center" style="width:8%;">ปี(สินค้า)</th>' +
            '<th class="text-center" style="width:10%;">รหัสทรัพย์สิน(บัญชี)</th>' +
            '<th class="text-center" style="width:5%;">BARCODE COOLING</th>' +
            '<th class="text-center">รหัสสินค้า</th>' +
            '<th class="text-center">ชื่อสินค้า</th>' +
            '<th class="text-center" style="width:5%;">รหัสประเภทสินค้า</th>' +
            '<th class="text-center">ชื่อประเภทสินค้า</th>' +
            '<th class="text-center" style="width:5%;">วันที่เริ่มต้น</th>' +
            '<th class="text-center">ระยะเวลาประกัน(วัน)</th>' +
            '<th class="text-center">อายุของทรัพย์สิน(วัน)</th>' +
            '<th class="text-center">รหัสเจ้าของทรัพย์สิน</th>' +
            '<th class="text-center">ชื่อเจ้าของทรัพย์สิน</th>' +
            '<th class="text-center">รหัส Supplier</th>' +
            '<th class="text-center">ชื่อ Supplier</th>' +
            '<th class="text-center">สถานะทรัพย์สินเช่า</th>';
          if (hasBarcodeId) {
            head += '<th class="text-center">BARCODE ID</th>';
          }
          head += '</tr></thead>';

          $table.append(head);
          var data = response.data;
          var table_body = $("<tbody></tbody>");
          for (var i = 0; i < data.length; i++) {
            var borders_assetDB = null;
            var borders_startDate = null;
            var borders_longDate = null;
            var borders_exprie = null;
            var borders_oldBarcode = null;
            var borders_isLeasedAssets = null;
            var borders_VenderCode = null;
            var borders_VenderName = null;
            var borders_plantOwnerName = null;
            var borders_plantOwnerId = null;
            var borders_productypeID = null;
            var borders_productypeName = null;
            var borders_productName = null;
            var borders_materialcode = null;
            var borders_assetAc = null;
            var borders_barcodeYear = null;
            var borders_cooling = null;
            var borders_barcodeID = "";

            if (data[i].assetDBMS == null || data[i].assetDBMS == "") {
              borders_assetDB = 'style="color:#ff0000;"';
              data[i].assetDBMS = "";
            }

            if (data[i].startDate == null || data[i].startDate == "") {
              borders_startDate = 'style=" color:#ff0000;"';
              data[i].startDate = "กรุณากรอกวันที่เริ่มต้น"
              self.isPass = false;
            }

            if (data[i].IsstartDate == true) {
              borders_startDate = 'style="color:#ff0000;"';
            }

            if (data[i].longDate == null || data[i].longDate == "") {
              borders_longDate = 'style="color:#ff0000;"';
              data[i].longDate = "กรุณากรอกระยะเวลาประกันถัง(วัน)"
              self.isPass = false;
            }

            if (data[i].isLeasedAssets == null) {
              data[i].isLeasedAssets = "กรุณากรอกสถานะทรัพย์สินเช่า"
              borders_isLeasedAssets = 'style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].barcodeYear == null  ){
              data[i].barcodeYear = 0
            }

            if (data[i].barcodeOld != null) {
              if (
                data[i].barcodeOld.length != 7 ||
                data[i].barcodeOldCount >= 1
              ) {
                borders_oldBarcode = 'style="color:#ff0000;"';
              }
            }
            else if (data[i].barcodeOld == null || data[i].barcodeOld == "") {
              data[i].barcodeOldMS= "กรุณากรอก BARCODE";
              borders_oldBarcode='style="color:#ff0000;"';
              self.isPass = false;
            }

            if (data[i].assetDB != null) {
              if (data[i].assetDBCount >= 1) {
                borders_assetDB = 'style="color:#ff0000;"';
                self.isPass = false;
              }
            }

            if(data[i].vendorMS == null){
              data[i].vendorMS = "กรุณากรอกรหัส Supplier";
              borders_VenderCode='style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].vendorCount>0){
              borders_VenderCode='style="color:#ff0000;"';
              borders_VenderName='style="color:#ff0000;"';
              self.isPass = false;
            } 

            if(data[i].vendorName == null){
              data[i].vendorName = "";
              borders_VenderName='style="color:#ff0000;"';
            }

            if(data[i].plantOwnerID == null || data[i].plantOwnerID == ""){
              data[i].plantOwnerID= "กรุณากรอกรหัสเจ้าของทรัพย์สิน";
              borders_plantOwnerId='style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].plantOwnerName == null || data[i].plantOwnerName == ""){
              data[i].plantOwnerName= "";
              borders_plantOwnerName='style="color:#ff0000;"';
            }

            if(data[i].exprie == null || data[i].exprie == ""){
              data[i].exprie= "กรุณากรอกอายุของทรัพย์สิน(วัน)";
              borders_exprie='style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].productypeID == null || data[i].productypeID == ""){
              data[i].productypeID= "กรุณากรอกรหัสประเภทสินค้า";
              borders_productypeID='style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].productypeName == null || data[i].productypeName == ""){
              data[i].productypeName= "";
              borders_productypeName='style="color:#ff0000;"';
            }

            if(data[i].productName == null || data[i].productName == ""){
              data[i].productName= "";
              borders_productName='style="color:#ff0000;"';
            }

            if(data[i].materialcode == null || data[i].materialcode == ""){
              data[i].materialcode= "กรุณากรอกรหัสสินค้า";
              borders_materialcode='style="color:#ff0000;"';
              self.isPass = false;
            }

            if(data[i].assetAc == null || data[i].assetAc == ""){
              data[i].assetAc= "";
              borders_assetAc='style="color:#ff0000;"';
            }

            if(data[i].barcodeCooling != null && data[i].barcodeCooling != "" && data[i].barcodeCoolingCount > 0){
              borders_cooling='style="color:#ff0000;"';
              self.isPass = false;
            }

            if (data[i].BarcodeId == null || data[i].BarcodeId <= 0) {
              data[i].BarcodeId = "";
              borders_barcodeID = 'style="color:#ff0000;"';
            }

            var showbarcode = data[i].barcodeYear ; 
            if (data[i].assetYearDBMS != null && data[i].assetYearDBMS != "") {
              showbarcode = '<span style="color:#ff0000;">'+data[i].assetYearDBMS+'</span>'; 
            } 
            else{ 
              if( data[i].barcodeYear <=0){
                showbarcode = "";
              }
            }

            var row = '<tr role="row" class="odd">' +
              '<td class="text-center">' + (i + 1) + '</td>' +
              '<td class="text-center" ' + borders_oldBarcode + '>' + data[i].barcodeOldMS + '</td>' +
              '<td class="text-center" ' + borders_assetDB + '>' + data[i].assetDBMS + '</td>' +
              '<td class="text-center" ' + borders_barcodeYear + '>' + showbarcode + '</td>' +
              '<td class="text-center" ' + borders_assetAc + '>' + data[i].assetAc + '</td>' +
              '<td class="text-center" ' + borders_cooling + '>' + data[i].barcodeCooling + '</td>' +
              '<td class="text-center" ' + borders_materialcode + '>' + data[i].materialcode + '</td>' +
              '<td class="text-center" ' + borders_productName + '>' + data[i].productName + '</td>' +
              '<td class="text-center" ' + borders_productypeID + '>' + data[i].productypeID + '</td>' +
              '<td class="text-center" ' + borders_productypeName + '>' + data[i].productypeName + '</td>' +
              '<td class="text-center" ' + borders_startDate + '>' + data[i].startDate + '</td>' +
              '<td class="text-center" ' + borders_longDate + '>' + data[i].longDate + '</td>' +
              '<td class="text-center" ' + borders_exprie + '>' + data[i].exprie + '</td>' +
              '<td class="text-center" ' + borders_plantOwnerId + '>' + data[i].plantOwnerID + '</td>' +
              '<td class="text-center" ' + borders_plantOwnerName + '>' + data[i].plantOwnerName + '</td>' +
              '<td class="text-center" ' + borders_VenderCode + '>' + data[i].vendorMS + '</td>' +
              '<td class="text-center" ' + borders_VenderName + '>' + data[i].vendorName + '</td>' +
              '<td class="text-center" ' + borders_isLeasedAssets + '>' + data[i].isLeasedAssets + '</td>';
            if (hasBarcodeId) {
              row += '<td class="text-center" '+ borders_barcodeID + '>' + data[i].BarcodeId + '</td>';
            }
            row += '</tr>';
            $(row).appendTo(table_body);
          }

          table_body.appendTo($table);
          KTApp.unblockPage();
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถอ่านข้อมูลจากไฟล์ที่นำเข้า", "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    });

  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  cursor: pointer;
}
td.border_single {
  border: 1px solid #ff0000;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/ImportBarcode.vue